import { LogArgument } from "rollbar";
import * as Rollbar from "rollbar";
import { DeviceDetection } from "./DeviceDetection";

const rollbarEnabled = window.location.host.toLowerCase().indexOf(".sofi.com") > -1;

const onSendCallback = (isUncaught: boolean, args: LogArgument[], item: any) => {
  if (!!item) {
    if (!!item.body) {
      const jsonBody = JSON.stringify(item.body);
      item.body = JSON.parse(redactUuid(jsonBody));
    }
    if (!!item.request) {
      const jsonRequest = JSON.stringify(item.request);
      item.request = JSON.parse(redactUuid(jsonRequest));
    }
  }
};

const redactUuid = (text: string): string => {
  return text.replace(/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/g, "$UUID");
};

const rollbarConfig = {
  accessToken: "bc7ac06935f8457584d7ef7a7f497a78",
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: rollbarEnabled,
  onSendCallback,
  payload: {
    environment: "production",
  },
  scrubFields: ["request.url"],
};

export class Logger {
  private static rollbar = Rollbar.init(rollbarConfig);
  public static error = (...args: Rollbar.LogArgument[]) => {
    Logger.rollbar.error(args, DeviceDetection.getTags);
  };

  public static warn = (...args: Rollbar.LogArgument[]) => {
    Logger.rollbar.warn(args, DeviceDetection.getTags);
  };

  public static info = (...args: Rollbar.LogArgument[]) => {
    Logger.rollbar.info (args, DeviceDetection.getTags);
  };

  public static infoWithId = (id: string, ...args: Rollbar.LogArgument[]) => {
    const message = `id:${id}, message:${args}`;
    Logger.rollbar.info(message);
  };
}



// WEBPACK FOOTER //
// ./src/constants/Logger.ts